var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-input",
    _vm._b(
      {
        staticClass: "w-select",
        class: { focus: _vm.isFocused, disabled: _vm.disabled },
        on: { input: _vm.input },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var inputType = ref.inputType
              var value = ref.value
              var listeners = ref.listeners
              return [
                _c(
                  "vue-multiselect",
                  _vm._g(
                    _vm._b(
                      {
                        staticClass: "input",
                        class: { inline: _vm.inModal },
                        attrs: {
                          multiple: !_vm.single,
                          "close-on-select": _vm.single,
                          "clear-on-select": _vm.single,
                          taggable: _vm.$listeners.add,
                          label: _vm.optionLabel,
                          "block-keys": ["Tab", "Enter"],
                          "custom-label":
                            _vm.customLabel || _vm.thisCustomLabel,
                        },
                        on: { tag: _vm.add, open: _vm.open, close: _vm.close },
                        scopedSlots: _vm._u(
                          [
                            _vm.$scopedSlots.singleLabel
                              ? {
                                  key: "singleLabel",
                                  fn: function (ref) {
                                    var option = ref.option
                                    return [
                                      _vm._t("singleLabel", null, null, option),
                                    ]
                                  },
                                }
                              : null,
                            {
                              key: "option",
                              fn: function (ref) {
                                var option = ref.option
                                return [
                                  _vm._t(
                                    "option",
                                    function () {
                                      return [
                                        _c("div", {
                                          staticClass: "title",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              option[_vm.optionTitle]
                                            ),
                                          },
                                        }),
                                        _vm.optionDescription
                                          ? _c("div", {
                                              staticClass: "description",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  option[_vm.optionDescription]
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                    null,
                                    option
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      "vue-multiselect",
                      {
                        placeholder: _vm.placeholder,
                        tagPlaceholder: _vm.tagPlaceholder,
                        value: value,
                        options: _vm.options,
                        trackBy: _vm.trackBy,
                        disabled: _vm.disabled,
                      },
                      false
                    ),
                    listeners
                  )
                ),
              ]
            },
          },
        ]),
      },
      "w-input",
      {
        value: _vm.value,
        label: _vm.label,
        required: _vm.required,
        disabled: _vm.disabled,
      },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }